/**
* @author 贝才[beica1@outook.com]
* @date 2021/3/3
* @description
*   TheCreateLimits.vue of WeTrade
*/
<template>
<div class="df-middle f-md">
  <t class="flex-1" as="p" path="placeorder_13">Commission</t>
  <money as="p" class="flex-1 c-primary f-medium" :v="noFee ? 0: prop('sxf', product)" />
  <t as="p" path="placeorder_14" class="flex-1">Swap</t>
  <div class="flex-1">
    <money class="flex-1 t-text f-medium"
      :v="(noFee || islamFlag) ? 0 : prop('deferred', product)" />/day
  </div>
</div>
<Line class="mt-16" />
<TheStopLoss />
<Line />
<TheTakeProfit />
</template>

<script lang="ts">
import Line from '@/components/Line.vue'
import TheStopLoss from '@/modules/trade/components/TheStopLoss.vue'
import TheTakeProfit from '@/modules/trade/components/TheTakeProfit.vue'
import Order from '@/modules/trade/Order'
import { computed, defineComponent, inject } from 'vue'
import { localGet } from 'essential/store/localStore'
import { keymap } from '@/config'

export default defineComponent({
  name: 'TheTradeLimits',
  components: {
    TheTakeProfit,
    Line,
    TheStopLoss,
  },
  setup () {
    const order = inject('order') as Order
    const noFee = computed(() => order.useCoupon.value)

    return {
      noFee,
      product: order.getProduct(),
      islamFlag: Boolean(Number(localGet(keymap.user.islamFlag))) || false,
    }
  },
})
</script>
